import { ROUTES } from "../utils";

const normalize = (p: string) =>
  p.endsWith("/") && p !== "/" ? p.slice(0, -1) : p;

const toPrefix = (pattern: string) => {
  const idx = pattern.indexOf("/:");
  return idx === -1 ? pattern : pattern.slice(0, idx + 1);
};

const ROUTE_CAPS: Array<{ prefix: string; cap: string }> = [

  { prefix: ROUTES.DASHBOARD, cap: "home:dashboard:view" },

  // PERFORMANCE OPTIMISATION
  { prefix: ROUTES.GEOSPATIAL, cap: "performance_optimisation:geospatial:view" },
  { prefix: ROUTES.PROGRAMME_DASHBOARD, cap: "performance_optimisation:performance_insights:view" },
  { prefix: ROUTES.INVESTMENT_OVERSIGHT, cap: "performance_optimisation:investment_oversight:view" },
  { prefix: ROUTES.CONTRACTOR_OVERSIGHT, cap: "performance_optimisation:contractor_oversight:view" },
  { prefix: ROUTES.LIVE_PROGRESS, cap: "performance_optimisation:live_progress:view" },
  { prefix: ROUTES.GEOSPATIAL_PROJECTS, cap: "performance_optimisation:geospatial_projects:view" },

  // COMMERCIAL CONTROLLER
  { prefix: ROUTES.COMMERCIAL_DASHBOARD, cap: "commercial_controller:commercial_programme_dashboard:view" },
  { prefix: ROUTES.BUDGETS_VS_ACTUALS, cap: "commercial_controller:budget_vs_actuals:view" },
  { prefix: ROUTES.COMMITMENTS_AND_ACCRUALS, cap: "commercial_controller:commitments_and_accruals:view" },
  { prefix: ROUTES.TRENDS_AND_FORECASTS, cap: "commercial_controller:trends_and_forecasts:view" },
  { prefix: ROUTES.FORECAST_VARIANCE, cap: "commercial_controller:forecast_variance:view" },
  { prefix: ROUTES.REQUESTS_PIPELINE, cap: "commercial_controller:procurement_pipeline:view" },

  // OPERATIONAL DELIVERY
  { prefix: ROUTES.PORTFOLIO, cap: "operational_delivery:portfolio_manager:view" },
  { prefix: ROUTES.PROJECTS, cap: "operational_delivery:project_manager:view" },
  { prefix: ROUTES.TASKS, cap: "operational_delivery:task_manager:view" },
  { prefix: ROUTES.JEOPARDY_MANAGER, cap: "operational_delivery:jeopardy_manager:view" },

  // COLLABORATION
  { prefix: ROUTES.QUERIES, cap: "collaboration:queries_and_rfis:view" },
  { prefix: ROUTES.MEETING_MANAGER, cap: "collaboration:meetings_manager:view" },
  { prefix: ROUTES.DOCUMENT_MANAGER, cap: "collaboration:document_manager:view" },

  // RISK & COMPLIANCE
  { prefix: ROUTES.RISK_DASHBOARD, cap: "risk_compliance:risk_dashboard:view" },
  { prefix: ROUTES.COMPLIANCE, cap: "risk_compliance:compliance_manager:view" },

  // VISION STUDIO
  { prefix: ROUTES.VISION_STUDIO, cap: "vision_studio:vision_studio:view" },

  // REPORTING ZONE
  { prefix: ROUTES.IMPORT_MANAGER, cap: "reporting:import_manager:view" },
  { prefix: ROUTES.IMPORT_BATCH_DETAIL, cap: "reporting:import_manager_details:view" },
  { prefix: ROUTES.EXPORT_MANAGER, cap: "reporting:custom_reports:view" },
  { prefix: ROUTES.EXPORT_AND_ANALYTICS, cap: "reporting:export_and_analytics:view" },
  { prefix: ROUTES.SCHEDULED_REPORTS, cap: "reporting:scheduled_reports:view" },

  // ADMINISTRATION
  { prefix: ROUTES.PORTFOLIO_SETUP, cap: "administration:portfolio_and_programme_setup:view" },
  { prefix: ROUTES.ROLES, cap: "administration:roles_and_permissions:view" },
  { prefix: ROUTES.INTERGRATIONS, cap: "administration:integrations:view" },
  { prefix: ROUTES.SUPPORT, cap: "administration:support_and_help:view" },

  { prefix: ROUTES.PROJECTS_DETAILS_DASHBOARD, cap: "operational_delivery:project_manager:dashboard:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_OVERVIEW, cap: "operational_delivery:project_manager:overview:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, cap: "operational_delivery:project_manager:schedule_and_planning:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_STAGE_GATES, cap: "operational_delivery:project_manager:stage_gates:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_RECURRING_TASKS, cap: "operational_delivery:project_manager:recurring_tasks:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_TASKS, cap: "operational_delivery:project_manager:tasks:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_QUERIES, cap: "operational_delivery:project_manager:queries_and_rfis:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_RISKS_AND_ISSUES, cap: "operational_delivery:project_manager:risks_and_issues:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_COMMERICIALS, cap: "operational_delivery:project_manager:commercials:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS, cap: "operational_delivery:project_manager:artefacts_and_documents:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_MATERIAL_REQUESTS, cap: "operational_delivery:project_manager:material_requests:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_RESOURCE_REQUESTS, cap: "operational_delivery:project_manager:resource_requests:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_CONFIGURAION, cap: "operational_delivery:project_manager:configuration:view" },
  { prefix: ROUTES.PROJECTS_DETAILS_ACTIVITY_LOGS, cap: "operational_delivery:project_manager:activity_logs:view" },

  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_DASHBOARD, cap: "operational_delivery:project_manager:dashboard:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_OVERVIEW, cap: "operational_delivery:project_manager:overview:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, cap: "operational_delivery:project_manager:schedule_and_planning:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_STAGE_GATES, cap: "operational_delivery:project_manager:stage_gates:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RECURRING_TASKS, cap: "operational_delivery:project_manager:recurring_tasks:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_TASKS, cap: "operational_delivery:project_manager:tasks:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_QUERIES, cap: "operational_delivery:project_manager:queries_and_rfis:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RISKS_AND_ISSUES, cap: "operational_delivery:project_manager:risks_and_issues:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_COMMERICIALS, cap: "operational_delivery:project_manager:commercials:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS, cap: "operational_delivery:project_manager:artefacts_and_documents:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_MATERIAL_REQUESTS, cap: "operational_delivery:project_manager:material_requests:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RESOURCE_REQUESTS, cap: "operational_delivery:project_manager:resource_requests:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_CONFIGURAION, cap: "operational_delivery:project_manager:configuration:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS_DETAILS_ACTIVITY_LOGS, cap: "operational_delivery:project_manager:activity_logs:view" },

  { prefix: ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD, cap: "operational_delivery:project_manager:portfolio_programme_dashboard:view" },
  { prefix: ROUTES.PORTFOLIO_PROJECTS, cap: "operational_delivery:project_manager:portfolio_projects:view" },

].sort((a, b) => b.prefix.length - a.prefix.length); // longest match first

export const findRequiredCapability = (pathname: string): string | null => {
  const path = normalize(pathname);
  const found = ROUTE_CAPS.find(({ prefix }) => path.startsWith(prefix));
  return found ? found.cap : null; // null => unrestricted route
};